import { getData } from "@atresmedia/elections_modules_library/dist/dataProvider";

import { getSite } from "../containers/moduleGenerator/utils";

export const getRoute = (town, community, excludes, reload, params) => {
  if (parseInt(reload) === 2) {
    return getStaticRoute(town);
  }
  return getNewsRoute(town, community, excludes, params);
};

export const getNewsRoute = (town, community, excludes, params) => {
  let locale = "";
  if (town.path) {
    const path = town.path.split("/");
    locale = community ? path.pop() : path[1];
  } else {
    locale = town.name;
  }
  let ineId = community ? town.ineId : town.parentId;
  if (!ineId) ineId = community;

  if (excludes && Boolean(excludes[ineId])) {
    return excludes[ineId];
  }

  const { community: communityId } = getParams(town);
  const site = getSite();

  let resultPath = town.name;
  if (town.path) {
    resultPath = "/" + town.path.split("/").slice(2).join("/");

    return (params.sites[site].paths[communityId] || "")
      .replace("##locale##", locale)
      .replace("##ineId##", ineId)
      .replace("##resultPath##", resultPath);
  }

  /*if (site === LA_SEXTA) {
    // AdHoc para Antonio
    return "https://www.lasexta.com/noticias/nacional/elecciones-cataluna/resultados";
  }*/

  return (params.sites[site].paths[communityId] || "")
    .replace("##locale##", locale)
    .replace("##ineId##", ineId)
    .replace("##resultPath##", resultPath);
};

export const getStaticRoute = town => {
  const host = window.location.hostname.replace("localhost", "ondacero.es");
  const { community: communityId } = getParams(town);

  // TODO LOGICA PARA DIFERENCIAR LAS URL POR TYPE
  //  province/town le quito lo ultimo
  // no se hace en a3

  let path = "";
  if (town.path) {
    path = town.path;
  }

  return setStaticUrl(host, communityId, path);
};

const setStaticUrl = (host, communityId, path) => {
  const resultPath = "/" + path.split("/").slice(2).join("/");

  if (host.indexOf("lasexta") !== -1) {
    if (resultPath !== "/") {
      return `https://www.lasexta.com/noticias/nacional/elecciones-cataluna/resultados${resultPath}`;
    } else {
      return `https://www.lasexta.com/noticias/nacional/elecciones-cataluna/resultados`;
    }
  }
  if (host.indexOf("ondacero") !== -1) {
    if (resultPath !== "/") {
      return `https://www.ondacero.es/noticias/elecciones-cataluna/resultados/cataluna${resultPath}`;
    } else {
      return `https://www.ondacero.es/noticias/elecciones-cataluna/resultados/cataluna`;
    }
  }

  return "";
};

export const navigateTo = (
  history,
  reload,
  internalPath,
  item,
  community,
  excludes,
  params
) => {
  if (parseInt(reload) === 0) {
    history.push(internalPath);
  } else if (parseInt(reload) === 1) {
    const path = getNewsRoute(item, community, excludes, params);
    window.parent.location.href = path;
  } else if (parseInt(reload) === 2) {
    const pathPromise = () => {
      if (item.path) {
        return item;
      }
      const { community: communityId } = getParams(item);
      return getData(communityId);
    };
    Promise.resolve(pathPromise()).then(item => {
      const path = getStaticRoute(item);
      if (path) {
        window.parent.location.href = path;
      } else {
        history.push(internalPath);
      }
    });
  }
};

export const getParams = location => {
  if (location) {
    switch (location.typePlace) {
      case "REGION":
        return { community: location.ineId };
      case "PROVINCE":
        return { community: location.parentId, province: location.ineId };
      case "TOWN":
        return {
          community: location.grandpaId,
          province: location.parentId,
          town: location.ineId
        };
      default:
        return { community: location.parentId };
    }
  } else {
    return {};
  }
};
